export const blogs = {
  items: 1,
  data: [{
    creationTime: 1500097896308,
    title: 'Hello',
    slug: 'hello',
    markDown: '## The first blog\n Hi there, this is the first article.\nSee you next time.'
  }]
};



// WEBPACK FOOTER //
// ./src/data/tmp/blogs.js